<template>
  <div>
    <video :id="nodeId" style="width: 100%"></video>
  </div>
</template>

<script>
  import { BrowserMultiFormatReader } from '@zxing/library';

  export default {
    name: 'QRCodeScanner',
    props: {
      readEnable: { PropType: Boolean, default: false },
      onScan: Function
    },
    data() {
      return {
        codeReader: undefined,
        nodeId: (new Date()).getTime().toString()
      }
    },
    methods: {
      readStart() {
        this.codeReader.decodeFromVideoDevice(undefined, this.nodeId, (result) => 
        {
          if (result) {
            this.onScan(result.text)
          }
        })
      },
      readStop() {
        this.codeReader.reset()
      }
    },
    mounted() {
      this.codeReader = new BrowserMultiFormatReader()
    },
    watch: {
      readEnable(newVal) {
        if(newVal)
        {
          this.readStart()
        }
        else {
          this.readStop()
        }
      }
    }
  }
</script>
